import { render, staticRenderFns } from "./PropostaGrid.vue?vue&type=template&id=e3804db4"
import script from "./PropostaGrid.vue?vue&type=script&lang=js"
export * from "./PropostaGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports